<main class="page">
  <!-- File upload section -->
  <section class="input-section">
    <tech-card>
      <input-file (filesLoaded)="onFilesLoaded($event)" />
    </tech-card>
  </section>
  <!-- Staged table (shows immediately) -->
  <div class="down-section">
    <tech-card>
      <section techScrollbars class="table-section">
        <div class="def-bar">
          <h2>{{ 'general.cachedFiles' | translate }}</h2>
          <div class="upload-cancel">
            <button
              techButton
              techButtonColor="success"
              class="upload-to-permanent"
              [disabled]="uploading || loading"
              (click)="handleUpload($event)"
            >
              {{ upload_field_text | translate }} ({{ staged_file_count }})
              @if (uploading) {
                <tech-loader></tech-loader>
              }
            </button>
            <a
              techButton
              techTooltip="{{ 'general.clearCachedFiles' | translate }}"
              techButtonColor="danger"
              class="cancel-upload"
              (click)="cancelUpload()"
            >
              🗑
            </a>
          </div>
          <section class="bar-right-section">
            <button techIconRoundButton (click)="callme()">
              <tech-icon>manage_search</tech-icon>
            </button>
          </section>
        </div>
        <!-- Staged table: shows the staged files with error anotations  -->
        @if (!loading && !stage_errors && something_uploaded) {
          <div class="check-wrapper">
            <operation-result-check></operation-result-check>
          </div>
        } @else if (loading) {
          <div class="loader-wrapper">
            <tech-loader techLoadingSize="lg"></tech-loader>
          </div>
        } @else if (stage_errors) {
          <div class="table-wrapper">
            <stage-table
              [displayColumns]="display_columns"
              [stagedReceipts]="staged_receipts"
            />
          </div>
        } @else {
          <div class="text-wrapper">
            <tech-message [icon]="'info'" [type]="'info'">
              {{ 'general.uploadFilesToStart' | translate }}
            </tech-message>
          </div>
        }
      </section>
    </tech-card>
  </div>
</main>
